/** Minuscules, sans accents ni espaces autour : « École » et « ecole » se valent. */
export function normalizeSearch(text: string): string {
  return text.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().trim()
}

/** Les mots d'une recherche, normalisés, sans vide. */
export function searchWords(query: string): string[] {
  return normalizeSearch(query).split(/\s+/).filter(Boolean)
}

/**
 * Vrai si chaque mot de `query` figure dans l'un des `fields` (#107). Requête
 * vide = tout passe. Les mots se cherchent champ par champ, pas dans leur
 * concaténation : « ab » ne doit pas trouver un « a » suivi d'un « b ».
 */
export function matchesQuery(query: string, fields: ReadonlyArray<string | null | undefined>): boolean {
  const words = searchWords(query)
  if (words.length === 0) return true
  const haystacks = fields.filter((field): field is string => !!field).map(normalizeSearch)
  return words.every(word => haystacks.some(haystack => haystack.includes(word)))
}
